// Verzoeken van een gast met leesrechten (Tristan). Hij dient in via de databasefunctie dien_verzoek_in,
// Furgel keurt goed of wijst af. Goedkeuren legt alleen de beslissing vast; er wordt niets automatisch uitgevoerd.
import { useCallback, useEffect, useState } from "react";
import { supabase } from "../supabase";
import { C, Chip, Portal, datumNl, lees } from "./gedeeld";
import { logLezer } from "./lezerAudit";

const KLEUR = { open: C.yellow, goedgekeurd: C.green, afgewezen: C.red };

// Voor de gast: formulier plus de eigen verzoeken met hun status.
export function VerzoekFormulier({ onSluit }) {
  const [tekst, setTekst] = useState("");
  const [bezig, setBezig] = useState(false);
  const [fout, setFout] = useState("");
  const [lijst, setLijst] = useState([]);

  const laad = useCallback(async () => {
    const r = await lees(supabase.from("lezer_verzoeken").select("id,tekst,status,reactie,created_at").order("created_at", { ascending: false }).limit(30));
    setLijst(r.data);
  }, []);
  useEffect(() => { laad(); }, [laad]);

  async function dienIn() {
    setBezig(true); setFout("");
    const { error } = await supabase.rpc("dien_verzoek_in", { p_tekst: tekst });
    setBezig(false);
    if (error) { setFout(error.message || "Indienen mislukt"); return; }
    logLezer("verzoek", tekst.slice(0, 120));
    setTekst("");
    laad();
  }

  return (
    <Portal>
      <div className="ovl" style={{ zIndex: 10001 }} onClick={onSluit}>
        <div className="mdl" style={{ maxWidth: 520, width: "92vw" }} onClick={(e) => e.stopPropagation()}>
          <h3 style={{ marginTop: 0 }}>Verzoek indienen</h3>
          <p style={{ fontSize: 12, color: C.muted }}>Wil je iets laten aanpassen of toevoegen? Schrijf het hier op. Furgel beoordeelt het.</p>
          <textarea value={tekst} onChange={(e) => setTekst(e.target.value)} maxLength={2000} rows={4} placeholder="Wat wil je laten doen?" style={{ width: "100%", boxSizing: "border-box" }} />
          {fout && <p style={{ fontSize: 12, color: C.red }}>{fout}</p>}
          <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", margin: "10px 0 14px" }}>
            <button className="btn bg" onClick={onSluit}>Sluiten</button>
            <button className="btn bp" disabled={bezig || tekst.trim().length < 3} onClick={dienIn}>{bezig ? "Versturen..." : "Indienen"}</button>
          </div>
          {lijst.length > 0 && <p className="lbl">Jouw verzoeken</p>}
          {lijst.map((v) => (
            <div key={v.id} style={{ padding: "8px 0", borderTop: "1px solid " + C.border }}>
              <p style={{ fontSize: 13, margin: 0, whiteSpace: "pre-wrap" }}><Chip tekst={v.status} kleur={KLEUR[v.status] || C.muted} /> {v.tekst}</p>
              {v.reactie && <p style={{ fontSize: 12, color: C.muted, margin: "4px 0 0" }}>Reactie: {v.reactie}</p>}
              <p style={{ fontSize: 11, color: C.dim, margin: "2px 0 0" }}>{datumNl(v.created_at)}</p>
            </div>
          ))}
        </div>
      </div>
    </Portal>
  );
}

// Voor Furgel: open verzoeken met goedkeuren en afwijzen. Verdwijnt als er niets open staat.
export function VerzoekenInbox() {
  const [lijst, setLijst] = useState([]);
  const [reactie, setReactie] = useState({});
  const [bezig, setBezig] = useState("");
  const [fout, setFout] = useState("");

  const laad = useCallback(async () => {
    const r = await lees(supabase.from("lezer_verzoeken").select("id,door,tekst,created_at").eq("status", "open").order("created_at"));
    setLijst(r.data);
  }, []);
  useEffect(() => {
    laad();
    const t = setInterval(laad, 60000);
    return () => clearInterval(t);
  }, [laad]);

  async function beslis(id, status) {
    setBezig(id); setFout("");
    const { error } = await supabase.from("lezer_verzoeken").update({ status, reactie: (reactie[id] || "").trim() || null, beslist_at: new Date().toISOString() }).eq("id", id);
    setBezig("");
    if (error) { setFout(error.message || "Opslaan mislukt"); return; }
    laad();
  }

  if (!lijst.length) return null;
  return (
    <div className="card" style={{ marginBottom: 14, borderLeft: "3px solid " + C.blue }}>
      <p className="lbl" style={{ margin: "0 0 6px" }}>Verzoeken van Tristan ({lijst.length})</p>
      <p style={{ fontSize: 11, color: C.muted, margin: "0 0 8px" }}>Goedkeuren legt alleen je beslissing vast. Je voert de wijziging zelf uit.</p>
      {fout && <p style={{ fontSize: 12, color: C.red }}>{fout}</p>}
      {lijst.map((v) => (
        <div key={v.id} style={{ padding: "8px 0", borderTop: "1px solid " + C.border }}>
          <p style={{ fontSize: 13, margin: 0, whiteSpace: "pre-wrap" }}>{v.tekst}</p>
          <p style={{ fontSize: 11, color: C.dim, margin: "2px 0 6px" }}>{v.door} · {datumNl(v.created_at)}</p>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            <input value={reactie[v.id] || ""} onChange={(e) => setReactie({ ...reactie, [v.id]: e.target.value })} placeholder="Reactie (optioneel)" style={{ flex: 1, minWidth: 160 }} />
            <button className="btn bg" disabled={bezig === v.id} onClick={() => beslis(v.id, "goedgekeurd")}>Goedkeuren</button>
            <button className="btn bg" disabled={bezig === v.id} onClick={() => beslis(v.id, "afgewezen")}>Afwijzen</button>
          </div>
        </div>
      ))}
    </div>
  );
}

const SOORT_KLEUR = { login: C.green, uitgelogd: C.muted, scherm: C.blue, geblokkeerd: C.red, verzoek: C.yellow, venster: C.dim };
const tijdNl = (iso) => new Date(iso).toLocaleString("nl-NL", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit", second: "2-digit" });

// Voor Furgel: wat de lezer per inlog heeft gedaan. Bovenaan de inlogmomenten uit het inlogsysteem (niet te beinvloeden),
// daaronder per sessie de schermen en geblokkeerde pogingen die de app heeft gemeld.
export function LezerAudit() {
  const [regels, setRegels] = useState([]);
  const [inlogs, setInlogs] = useState([]);
  const [open, setOpen] = useState(null);
  const [laatst, setLaatst] = useState(null);
  const [nu, setNu] = useState(Date.now());

  useEffect(() => {
    let weg = false;
    const laad = async () => {
      // Hartslagregels (soort "venster") tellen alleen voor de online-status, niet voor de sessielijst.
      const r = await lees(supabase.from("lezer_audit").select("id,door,sessie,volgorde,tijd,soort,detail").neq("soort", "venster").order("tijd", { ascending: false }).limit(1000));
      const l = await lees(supabase.from("lezer_audit").select("tijd").order("tijd", { ascending: false }).limit(1));
      const i = await supabase.rpc("lezer_inlogs").then((x) => (Array.isArray(x.data) ? x.data : [])).catch(() => []);
      if (!weg) { setRegels(r.data); setInlogs(i); setLaatst(l.data[0] ? l.data[0].tijd : null); setNu(Date.now()); }
    };
    laad();
    const t = setInterval(laad, 30000);
    return () => { weg = true; clearInterval(t); };
  }, []);

  if (!regels.length && !inlogs.length && !laatst) return null;
  const online = laatst && nu - new Date(laatst).getTime() < 120000;
  const sessies = [];
  const kaart = {};
  [...regels].reverse().forEach((x) => {
    if (!kaart[x.sessie]) { kaart[x.sessie] = { id: x.sessie, start: x.tijd, door: x.door, regels: [] }; sessies.push(kaart[x.sessie]); }
    kaart[x.sessie].regels.push(x);
  });
  sessies.reverse();

  return (
    <details className="card" style={{ marginBottom: 14 }}>
      <summary style={{ cursor: "pointer", fontSize: 13, fontWeight: 600 }}>
        Activiteit van Tristan ({sessies.length} sessies){" "}
        {online ? <Chip tekst="nu online" kleur={C.green} /> : laatst ? <Chip tekst={"laatst gezien " + tijdNl(laatst)} kleur={C.muted} /> : null}
      </summary>
      {inlogs.length > 0 && (
        <div style={{ margin: "10px 0" }}>
          <p className="lbl" style={{ margin: "0 0 4px" }}>Inlogmomenten (inlogsysteem)</p>
          {inlogs.slice(0, 10).map((x, k) => <p key={k} style={{ fontSize: 12, margin: "2px 0", color: C.muted }}>{tijdNl(x.tijd)} · {x.actie} · IP {x.ip || "onbekend"}</p>)}
        </div>
      )}
      {sessies.slice(0, 20).map((s) => {
        const geblokkeerd = s.regels.filter((x) => x.soort === "geblokkeerd").length;
        const schermen = s.regels.filter((x) => x.soort === "scherm").length;
        return (
          <div key={s.id} style={{ borderTop: "1px solid " + C.border, padding: "8px 0" }}>
            <p onClick={() => setOpen(open === s.id ? null : s.id)} style={{ fontSize: 13, margin: 0, cursor: "pointer" }}>
              {tijdNl(s.start)} · {schermen} schermen {geblokkeerd > 0 && <Chip tekst={geblokkeerd + " geblokkeerd"} kleur={C.red} />}
            </p>
            {open === s.id && s.regels.map((x) => (
              <p key={x.id} style={{ fontSize: 12, margin: "3px 0 0 8px", color: C.muted }}>
                {tijdNl(x.tijd)} <Chip tekst={x.soort} kleur={SOORT_KLEUR[x.soort] || C.muted} /> {x.detail}
              </p>
            ))}
          </div>
        );
      })}
    </details>
  );
}
